import { Mail } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-[#050508] border-t border-white/5 py-12" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="font-heading text-xl text-white tracking-tight">NEXUS<span className="text-[#4F7CFF]">FORGE</span></span>
            </Link>
            <p className="text-[#A1A1AA] text-sm max-w-md mb-4">
              Premium game enhancements with instant delivery. Crypto payments accepted. 
              24/7 support and regular updates to keep you ahead of the competition.
            </p>
            <div className="flex gap-4">
              <a 
                href="https://discord.gg/efeySGKGJk" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#A1A1AA] hover:text-[#4F7CFF] transition-colors"
                data-testid="footer-discord"
              >
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
                </svg>
              </a>
              <a href="mailto:support@nexusforge.io" className="text-[#A1A1AA] hover:text-[#4F7CFF] transition-colors">
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-sm text-white mb-4 uppercase tracking-wider">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/products" className="text-[#A1A1AA] hover:text-white text-sm transition-colors">
                  All Products
                </Link>
              </li>
              <li>
                <Link to="/status" className="text-[#A1A1AA] hover:text-white text-sm transition-colors">
                  System Status
                </Link>
              </li>
              <li>
                <Link to="/dashboard" className="text-[#A1A1AA] hover:text-white text-sm transition-colors">
                  My Account
                </Link>
              </li>
              <li>
                <a 
                  href="https://discord.gg/efeySGKGJk" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-[#A1A1AA] hover:text-white text-sm transition-colors"
                >
                  Join Discord
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-heading text-sm text-white mb-4 uppercase tracking-wider">Legal</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/terms" className="text-[#A1A1AA] hover:text-white text-sm transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-[#A1A1AA] hover:text-white text-sm transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/refund" className="text-[#A1A1AA] hover:text-white text-sm transition-colors">
                  Refund Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/5 text-center">
          <p className="text-[#A1A1AA] text-sm">
            &copy; {new Date().getFullYear()} Nexus Forge. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
